export default {"src":"/_next/static/media/atletiek.68d12619.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};